// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5154":"a8a8835e2180f5fd","7909":"021ca930c0070830","8128":"72394f70306ab756","8266":"f086c48b70c52b4f"}[chunkId] + ".css";
};